import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TipologieCostruttiveFormComponent } from './dialogs/form/form.component';
import { TipologieCostruttiveRoutingModule } from './tipologie-costruttive-routing.module';
import { TipologieCostruttiveComponent } from './tipologie-costruttive.component';
import { CustomMaterialModule } from '../../material-module/material.module';
import { ResourcefulIndexModule } from '../../shared/resourceful-index/resourceful-index.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [TipologieCostruttiveComponent, TipologieCostruttiveFormComponent],
  imports: [
    CommonModule,
    TipologieCostruttiveRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class TipologieCostruttiveModule { }
